import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { WorkspaceType } from 'state/workspaces/model';
import { WorkspaceTab } from 'state/workspaces/tabs/tabs.model';

type Props = Readonly<{
  e2e?: string;
  paddingClassName?: string;
  dashboardTab: React.ReactNode;
  rightMenu: React.ReactNode;
  tabContent: React.ReactNode;
}>;

export function WorkspaceLayout({
  e2e,
  paddingClassName,
  dashboardTab,
  rightMenu,
  children,
  tabContent: content,
}: PropsWithChildren<Props>) {
  return (
    <div className="d-flex flex-column h-100 overflow-hidden" data-e2e={e2e}>
      <div className="d-flex w-100">
        <div className={classNames('border-bottom d-flex align-items-center', paddingClassName)}>{dashboardTab}</div>
        {children}
        {rightMenu}
      </div>
      {content}
    </div>
  );
}

type TabsListProps = Readonly<{
  tabs: WorkspaceTab[];
  workspace: WorkspaceType;
  addButton: React.ReactNode;
  children: (tab: WorkspaceTab, idx: number) => React.ReactNode;
}>;

export function TabsListLayout({ tabs, children, addButton, workspace }: TabsListProps) {
  return (
    <ul role="tablist" className="nav nav-tabs flex-nowrap w-100 border-0 " aria-label={`${workspace} workspace tabs`}>
      {tabs.map((tab, idx) => children(tab, idx))}
      <div className="flex-grow-1 border-bottom">{addButton}</div>
    </ul>
  );
}
